<template>
    <div class="original-colors">
        <div class="global-header">
            <nav class="container navbar navbar-light ">
                <div class="d-flex justify-content-between">
                    <a class="d-flex justify-content-between" href="#" v-on:click="back()">
                        <svg class="back-icon align-self-center" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="34" height="34">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z" />
                        </svg>
                        <div class="navbar-text align-self-center">{{ $t("Back") }}</div>
                    </a>
                </div>

                <cart :cart="cart" :total="cart ? cartTotal : null" cart-type="home" :site-slug="siteSlug"></cart>
            </nav>
        </div>

        <div class="container main-content">
            <div class="mb-4 mt-1 w-100" v-if="cart && cart.cart_menu_items.length">
                <div v-if="cart.variant === 'eat-in' && site_settings.table_numbers == 1" class="d-flex justify-content-between mb-4" >
                    <button class="bg-white border checkout-headline align-self-center text-left px-3 py-1" style="cursor: pointer" v-on:click="$modal.show('table-select')">{{ $t("Table no:") }} <span> {{ table_name }} </span></button>
                </div>

                <div class="row">
                    <div v-if="!user || !user.email" class="col">
                        <label>{{ $t("E-mail receipt") }}</label>
                        <input type="text" v-model="cart.customer_email" v-on:blur="updateEmail" :placeholder="$t('E-mail receipt')" class="form-control" :class="{ 'is-invalid': !isEmailValid() }">
                    </div>
                    <div v-if="cart.variant === 'click-and-collect'" class="col">
                        <label>{{ $t("Name") }}</label>
                        <input type="text" v-model="cart.customer_name" v-on:blur="updateCart" :placeholder="$t('Name')" class="form-control" :class="{ 'is-invalid': !cart.customer_name }" />
                    </div>
                </div>

                <div v-if="site_settings.require_phone_number == 1" class="mt-4">
                    <div class="row">
                        <div class="col-md-3">
                            <label>{{ $t("Phone prefix") }}</label>
                            <select v-model="cart.customer_phone_prefix_code" v-on:change="updateCart" class="custom-select" :class="{ 'is-invalid': !cart.customer_phone_prefix_code }">
                                <option v-for="prefix in phone_prefixes" :value="prefix.code">{{ prefix.name }} ({{ prefix.dial_code }})</option>
                            </select>
                        </div>
                        <div class="col-md-9 mt-2 mt-md-0">
                            <label>{{ $t("Phone number") }}</label>
                            <input type="text" v-model="cart.customer_phone" v-on:blur="updateCart" placeholder="Phone Number" class="form-control" :class="{ 'is-invalid': !cart.customer_phone }" />
                        </div>
                    </div>
                </div>

                <div v-if="cart.variant === 'click-and-collect' && drop_off_locations.length" class="mt-4">
                    <label>{{ $t("Drop off location") }}</label>
                    <select v-model="cart.drop_off_location_id" v-on:change="updateCart" class="custom-select" style="font-size: 14px">
                        <option :value="null">{{ $t("Select drop off location") }}</option>
                        <option v-for="location in drop_off_locations" :value="location.id">{{ location.name }}</option>
                    </select>
                </div>
            </div>

            <div v-if="cart && cart.cart_menu_items.length" class="checkout-headline mb-4">
                {{ $t("Order summary") }} <span v-if="Object.keys(enabledMenus).length > 1" class="text-headline">({{ variantName }})</span>

                <div v-if="cart.variant == 'click-and-collect'" class="d-flex align-items-center">
                    <span v-if="slotFormat === 'start_time'">{{ cart.extra.slot_text || $t('Pick-up time: unknown') }}</span>
                    <span v-else-if="slotFormat === 'start_time_end_time'">{{ cart.extra.slot_long_format_text || $t('Pick-up time: Unknown') }}</span>
                    <button class="btn btn-outline-success btn-sm ml-2" v-on:click="$router.push(`/${siteSlug}/select-slot?from-cart=1`)">{{ $t("Change") }}</button>
                </div>
            </div>

            <div v-if="cart && cart.cart_menu_items.length">
                <div class="order-summary-content p-4 mb-3" v-for="item in cart.cart_menu_items" :key="item.id">
                    <div class="order-summary-item d-flex justify-content-between">
                        <div class="order-name-item">
                            <ul class="list-unstyled">
                                <li>
                                    <h2>
                                        <span>{{ item.quantity }}x</span>
                                        <span class="text-primary">{{ item.name }}</span>
                                    </h2>
                                </li>

                                <li v-for="modifier in item.cart_menu_item_modifiers" :key="modifier.id">
                                    <span v-if="modifier.quantity != 1">{{ modifier.quantity }} *</span> {{ modifier.name }}
                                </li>

                                <li v-if="item.calories_amount > 0">
                                    <small class="item-calories text-muted font-italic">{{ item.calories_amount }} {{ $t("kcal") }}</small>
                                </li>
                            </ul>
                        </div>

                        <div class="btn-delete" v-on:click="removeItem(item.id)">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="34" height="34">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
                            </svg>
                        </div>
                    </div>

                    <div v-if="item.notes" class="font-italic">
                        {{ item.notes }}
                    </div>

                    <hr>

                    <div class="d-flex justify-content-between">
                        <div class="price align-self-center">{{ price(item) | moneyFormat }}</div>
                        <div class="btn-qty-sm align-self-center">
                            <button :disabled="item.quantity < 2 || quantityLoading" class="btn minus1" v-on:click="updateQuantity(item, item.quantity - 1)">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                                    <path d="M0 0h24v24H0z" fill="none" />
                                    <path d="M19 13H5v-2h14v2z" />
                                </svg>
                            </button>
                            <input class="quantity" min="0" v-model="item.quantity" v-on:input="updateQuantity(item, $event)" type="number">
                            <button class="btn add1" :disabled="quantityLoading" v-on:click="updateQuantity(item, item.quantity + 1)">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                                    <path d="M0 0h24v24H0z" fill="none" />
                                    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="order-summary-content p-4 mb-3" style="background-color: rgb(235, 255, 235)" v-for="promotion in cart.extra.discounts.promotions" :key="`promotion-${promotion.id}`">
                    <div class="order-summary-item d-flex justify-content-between">
                        <div class="order-name-item">
                            <ul class="list-unstyled">
                                <li>
                                    <h2>{{ promotion.name }}</h2>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <hr>

                    <div class="d-flex justify-content-between">
                        <div class="price align-self-center">- {{ promotion.amount | moneyFormat }}</div>
                    </div>
                </div>

                <div v-if="serviceChargePercentages.length && (cart.variant != 'click-and-collect' || clickAndCollectServiceChargeEnabled)">
                    <div class="checkout-headline py-4">{{ serviceChargeLabel }}</div>

                    <ul class="list-unstyled service-charge-list">
                        <li v-if="showNoServiceCharge">
                            <div class="radio form-check form-check-inline">
                                <input class="form-check-input" name="radio-group" type="radio" id="tip-0" v-model="cart.tip_percentage" value="0" v-on:change="changeTip">
                                <label class="form-check-label" for="tip-0">No service charge</label>
                            </div>
                        </li>
                        <li v-for="(percentage, index) in serviceChargePercentages" :key="index">
                            <div class="radio form-check form-check-inline">
                                <input class="form-check-input" name="radio-group" type="radio" :id="`tip-${index + 1}`" v-model="cart.tip_percentage" :value="percentage / 100" v-on:change="changeTip">
                                <label class="form-check-label" :for="`tip-${index + 1}`">{{ ((totalPrice() * percentage - 0.001) / 100) | moneyFormat }} ({{ percentage }}%)</label>
                            </div>
                        </li>
                        <li>
                            <div class="radio form-check form-check-inline">
                                <input class="form-check-input" name="radio-group" type="radio" id="custom-amount" v-model="customTip" :value="true" v-on:change="setCustomTip">
                                <label class="form-check-label" for="custom-amount">{{ $t("Custom amount") }}</label>
                            </div>
                        </li>

                        <li class="ml-4 pl-3" v-if="customTip">
                            <input type="text" v-model="customAmount" class="form-control" style="max-width: 175px">
                        </li>
                    </ul>
                </div>


                <div class="order-summary-content p-4 mb-3" style="background-color: #fafafa">
                    <div class="order-summary-item">
                        <div class="order-name-item">
                            <ul class="list-unstyled mb-0">
                                <li>
                                    <h2 class="mb-0 text-center text-primary">{{ $t("ALLERGENIC INGREDIENTS & GLUTEN MAY BE PRESENT") }}</h2>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <hr>

                    <p v-if="cart.variant == 'eat-in' && allergen_notice['eat-in']" class="mb-0 text-muted small" v-html="allergen_notice['eat-in']"></p>
                    <p v-else-if="cart.variant == 'click-and-collect' && allergen_notice['click-and-collect']" class="mb-0 text-muted small" v-html="allergen_notice['click-and-collect']"></p>
                    <p v-else class="mb-0 text-muted small">{{ $t("If you have any food allergies, intolerances or sensitivities check our filters option and/or please speak our team to ask for our detailed allergy information. Dish descriptions do not mention every ingredient. Our food is prepared in kitchens where allergenic ingredients & gluten is present. We are unable to guarantee that anything is 100% free of allergens or gluten.") }}</p>
                </div>
            </div>

            <div class="row" v-else-if="fetchedItems">
                <div class="col-sm-12">
                    <div class="text-center">
                        <div class="card-img-top py-4">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 95" width="100" height="95">
                                <defs>
                                    <clipPath id="c">
                                        <path d="M0 0h100v95H0z" />
                                    </clipPath>
                                    <filter id="a" filterUnits="objectBoundingBox" x="0%" y="0%" width="100%" height="100%">
                                        <feColorMatrix in="SourceGraphic" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                                    </filter>
                                    <mask id="e">
                                        <g filter="url(#a)">
                                            <use xlink:href="#b" />
                                        </g>
                                    </mask>
                                    <g id="d" clip-path="url(#c)">
                                        <path d="M24.14 18.18c0 .402-.32.726-.718.726a.721.721 0 01-.719-.726" />
                                    </g>
                                </defs>
                                <path d="M32.395 94.473h67.234v.293H32.395zm0 0" fill="#3f3d56" />
                                <path d="M87.082 44.746a1.438 1.438 0 01-.281 2.113l-6.957 4.82-3.063 2.06a.832.832 0 01-1.117-.169.843.843 0 01-.18-.687.83.83 0 01.407-.582l2.968-1.739 5.18-4.976-3.332-3.606 2.469-1.867zm0 0M70.719 90.105h-1.703L68.004 75.93l4.316-.125zm0 0" fill="#a0616a" />
                                <path d="M70.844 94.703c-.453.211-.836-1.48-1.219-1.101-1.07 1.058-2.71 1.293-4.14.828l.5-.004a.685.685 0 01-.422-.883.682.682 0 01.464-.418l1.141-.285 1.789-3.172 1.824-.125a4.424 4.424 0 01.805 3.75c-.164.687-.422 1.266-.742 1.41zm0 0" fill="#2f2e41" />
                                <path d="M82.05 90.105h-1.698L79.34 75.93l4.437-.871zm0 0" fill="#a0616a" />
                                <path d="M82.176 94.703c-.457.211-.836-1.48-1.215-1.101-1.074 1.058-2.711 1.293-4.14.828l.495-.004a.673.673 0 01-.394-.352.677.677 0 01.438-.95l1.14-.284 1.785-3.172 1.953-.25.047.082a5.1 5.1 0 01.54 4.145c-.165.523-.384.937-.65 1.058zm0 0" fill="#2f2e41" />
                                <path d="M83.98 40.434c-1.562.222-2.644 1.086-3.09 2.808l-2.874-5.355a1.592 1.592 0 01.5-2.016 1.566 1.566 0 012.136.316zm0 0" fill="#009e69" />
                                <path d="M86.996 74.438C80 77.558 72.844 77.94 65.54 75.93c2.668-10.43 5.816-19.864 5.797-27.61l7.152-.62 1.102 1.757a39.433 39.433 0 015.316 13.676zm0 0" fill="#2f2e41" />
                                <path d="M78.98 28.55c0 2.06-1.656 3.731-3.699 3.731s-3.699-1.672-3.699-3.73c0-2.059 1.656-3.73 3.7-3.73 2.042 0 3.698 1.671 3.698 3.73zm0 0" fill="#a0616a" />
                                <path d="M79.352 35.14l-4.563.25-.738-4.105 3.695-.62zm0 0" fill="#a0616a" />
                                <path d="M78.86 48.32l-5 .145-2.524.355c-1.238-4.129-2.281-8.246.246-11.691l2.957-2.984 4.441-.125.063.035a3.616 3.616 0 011.633 4.191c-1.102 3.613-1.809 7.02-1.817 10.074zm0 0" fill="#009e69" />
                                <path d="M71.21 59.887l-.308 4.273a.955.955 0 01-.879.883.957.957 0 01-1.007-.977l.101-4.18L72.2 48.075l.121-7.215 3.457-.125-.25 8.332zm0 0" fill="#a0616a" />
                                <path d="M76.145 41.36c-1.461-.602-2.832-.4-4.07.87l.171-6.09a1.575 1.575 0 011.434-1.492c.828-.074 1.57.52 1.691 1.352zm0 0" fill="#009e69" />
                                <path d="M83.11 45.152H71.765c2.648-7.07 3.5-13.644 0-19.277.062-1.691 2.21-3.156 3.886-2.996 1.97.191 4.625 1.656 4.993 3.617zm0 0" fill="#2f2e41" />
                                <path d="M46.957 22.57h-.516V8.273c0-4.57-3.675-8.273-8.207-8.273H8.207C3.672 0 0 3.703 0 8.273v78.422c0 4.575 3.672 8.278 8.207 8.278h30.027c4.532 0 8.207-3.703 8.207-8.278V32.746h.516zm0 0" fill="#3f3d56" />
                                <path d="M38.566 2.152h-3.918a2.948 2.948 0 01-.28 2.746A2.906 2.906 0 0131.948 6.2H14.746a2.9 2.9 0 01-2.414-1.3 2.959 2.959 0 01-.281-2.747H8.39c-3.383 0-6.125 2.766-6.125 6.18v78.309c0 3.41 2.742 6.18 6.125 6.18h30.175c3.383 0 6.13-2.77 6.13-6.18V8.332c0-3.414-2.747-6.18-6.13-6.18zm0 0" fill="#fff" />
                                <path d="M7.563 14.383h31.832v27.535H7.562zm0 0" fill="#e6e6e6" />
                                <path d="M19.336 45.313a2.336 2.336 0 01-2.328 2.347 2.338 2.338 0 01-2.328-2.347 2.338 2.338 0 012.328-2.348c1.289 0 2.328 1.05 2.328 2.347zm0 0" fill="#009e69" />
                                <path d="M18.172 45.117h-.969v-.976h-.39v.976h-.97v.39h.97v.981h.39v-.98h.969zm0 0" fill="#fff" />
                                <path d="M31.633 45.313A2.339 2.339 0 0129.3 47.66a2.338 2.338 0 01-2.328-2.347 2.338 2.338 0 012.328-2.348c1.289 0 2.332 1.05 2.332 2.347zm0 0" fill="#009e69" />
                                <path d="M30.469 45.117v.39h-2.332v-.39zm0 0" fill="#fff" />
                                <path d="M24.664 17.82h-2.516a.333.333 0 00-.332.336v1.114c0 .183.149.335.332.335h.418v1.668h1.68v-1.668h.418a.335.335 0 00.332-.335v-1.114a.333.333 0 00-.332-.336zm0 0" fill="#009e69" />
                                <path d="M27.184 28.012a13.144 13.144 0 01-2.25-7.735.27.27 0 00-.211-.273v-.48h-2.657v.472h-.039a.27.27 0 00-.27.274v.023c.208 2.941-.495 5.582-2.12 7.914a.775.775 0 00-.133.461l.289 9.059a.785.785 0 00.77.761h6.011a.785.785 0 00.77-.773l.113-8.797a1.586 1.586 0 00-.273-.906zm0 0" fill="#3f3d56" />
                                <use xlink:href="#d" mask="url(#e)" />
                                <path d="M26.234 31.02h-.726a1.915 1.915 0 00-1.89-1.633c-.942 0-1.743.691-1.888 1.633h-.726a.54.54 0 00-.531.625l.793 5.18H25.8l.96-5.165a.538.538 0 00-.527-.64zm0 0" fill="#009e69" />
                                <path d="M7.563 53.14h31.832v27.536H7.562zm0 0" fill="#e6e6e6" />
                                <path d="M19.336 84.07a2.336 2.336 0 01-2.328 2.348 2.338 2.338 0 01-2.328-2.348c0-1.297 1.043-2.351 2.328-2.351 1.289 0 2.328 1.054 2.328 2.351zm0 0" fill="#009e69" />
                                <path d="M18.172 83.875h-.969v-.98h-.39v.98h-.97v.387h.97v.984h.39v-.984h.969zm0 0" fill="#fff" />
                                <path d="M31.633 84.07a2.339 2.339 0 01-2.332 2.348 2.338 2.338 0 01-2.328-2.348c0-1.297 1.043-2.351 2.328-2.351a2.342 2.342 0 012.332 2.351zm0 0" fill="#009e69" />
                                <path d="M30.469 83.875v.387h-2.332v-.387zm0 0M29.746 72.703h.02a2.984 2.984 0 002.789-1.887c1.965-5.007-.43-10.68-5.375-12.726-4.942-2.04-10.598.305-12.684 5.262-2.086 4.957.168 10.687 5.059 12.855 1.117.5 2.418.258 3.28-.613a9.694 9.694 0 016.911-2.89zm0 0" fill="#fff" />
                                <path d="M27.957 66.473c0 1.793-1.445 3.25-3.223 3.25-1.78 0-3.226-1.457-3.226-3.25 0-1.797 1.445-3.25 3.226-3.25 1.778 0 3.223 1.453 3.223 3.25zm0 0" fill="#f9a825" />
                            </svg>
                        </div>
                        <div class="error-message">
                            <p class="card-text pb-3">{{ $t("There's nothing in your cart currently") }}</p>
                            <a class="btn btn-primary" :href="`/${siteSlug}`">{{ $t("Start ordering") }}</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-center small text-center" :class="{ 'mt-4': !cart || cart.cart_menu_items.length == 0 }">
                <p>{{ $t("By continuing, you are agreeing to accept our") }}
                    <a href="/pages/terms-and-conditions" target="_blank">{{ $t("Terms and Conditions") }}</a> {{ $t("and") }} <a href="/pages/privacy-policy" target="_blank">{{ $t("Privacy Policy") }}</a>.
                </p>
            </div>
        </div>


        <div class="container global-footer" v-if="cart && cart.cart_menu_items.length">
            <div class="d-flex justify-content-between my-4">
                <div class="checkout-price align-self-center">
                    <div class="align-self-center">
                        <span class="text-primary">
                            {{ cartTotal | moneyFormat }}
                        </span>
                    </div>
                </div>
                <div class="align-self-center">
                    <button type="button" class="btn btn-primary" v-on:click="createOrder">
                        <span v-if="cartTotal > 0">{{ $t("Submit and pay") }}</span>
                        <span v-else>{{ $t("Submit") }}</span>
                    </button>
                </div>
            </div>
        </div>

        <table-select-modal v-if="cart && cart.cart_menu_items.length && site_settings.table_numbers" v-model="cart.table_id" v-on:apply="updateTableNumber" :tables="tables" modal-name="table-select"></table-select-modal>
        <cover-select-modal v-if="cart && cart.cart_menu_items.length" v-model="cart.covers" v-on:apply="updateCovers" modal-name="covers-select"></cover-select-modal>
        <error-modal :errors="errors" modal-name="error-modal"></error-modal>
    </div>
</template>

<script>
import Cart from '../../components/Cart'
import TableSelectModal from "../../components/modals/TableSelectNew";
import CoverSelectModal from "../../components/modals/CoverSelect";
import ErrorModal from "../../components/modals/Error";

export default {
    components: { Cart, TableSelectModal, CoverSelectModal, ErrorModal },
    data() {
        return {
            cart: null,
            tables: [],
            previousUrl: null,
            siteSlug: this.$route.params.site,
            errors: [],
            serviceChargeLabel: null,
            serviceChargePercentages: [],
            customTip: false,
            customAmount: 0,
            quantityLoading: false,
            showNoServiceCharge: true,
            variants: window.app.variants,
            enabledMenus: window.app.enabled_menus,
            user: window.app.user,
            clickAndCollectServiceChargeEnabled: true,
            allergen_notice: window.app.allergen_notice,
            fetchedItems: false,
            slotFormat: window.app.slot_format,
            phone_prefixes: window.phone_prefixes,
            site_settings: {
                default_country: window.app.default_country,
                require_phone_number: window.app.require_phone_number,
                table_numbers: window.app.table_numbers,
            },
            drop_off_locations: [],
        }
    },
    watch: {
        customAmount() {
            this.cart.tip_percentage = this.customAmount != 0
                ? this.customAmount / this.totalPrice()
                : 0.0000000001;
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => vm.previousUrl = from)
    },
    computed: {
        table_name() {
            let table = this.tables.find(t => t.id == this.cart.table_id);

            return table ? table.name : this.$t('Not selected');
        },
        variantName() {
            return this.variants[this.cart.variant].name;
        },
        cartTotal() {
            return Math.max(0, this.floor(
                this.totalPrice()
                + this.tipAmount()
                - this.totalDiscount())
            )
        }
    },
    methods: {
        fetch() {
            this.$axios
                .get(`/${this.siteSlug}/carts`)
                .then(response => {
                    response.data.item.tip_percentage = response.data.default_service_charge / 100;

                    this.cart = response.data.item;
                    if (this.cart.variant == 'eat-in' && this.cart.customer_phone_prefix_code == null && this.site_settings.require_phone_number == 1) {
                        this.cart.customer_phone_prefix_code = this.site_settings.default_country;
                    }

                    if (this.cart.variant == 'click-and-collect' && this.cart.customer_phone_prefix_code == null) {
                        this.cart.customer_phone_prefix_code = this.site_settings.default_country;
                    }

                    this.serviceChargeLabel = response.data.service_charge_label;
                    this.serviceChargePercentages = response.data.service_charge_percentages;
                    this.showNoServiceCharge = response.data.show_no_service_charge;
                    this.clickAndCollectServiceChargeEnabled = response.data.click_and_collect_service_charge_enabled;

                    if (this.cart.variant == 'click-and-collect' && !this.clickAndCollectServiceChargeEnabled) {
                        this.cart.tip_percentage = 0;
                    }

                    this.drop_off_locations = response.data.drop_off_locations;
                })
                .catch(error => {
                    // cart not found
                })
                .finally(() => {
                    this.fetchedItems = true;
                });
        },
        fetchTables() {
            this.$axios
                .get(`/${this.siteSlug}/carts/tables`)
                .then(response => this.tables = response.data.items)
                .catch(() => this.$router.back());
        },
        async updateCart() {
            await this.$axios
                .put(`/${this.siteSlug}/carts`, {
                    cart: this.cart
                })
                .then(response => {
                    response.data.item.tip_percentage = this.cart.tip_percentage;

                    this.cart = response.data.item;
                })
                .catch(error => {
                    if (error.response.data.message) {
                        this.$toasted.error(error.response.data.message, { duration: 3000, position: "bottom-center", theme: "toasted-primary" });
                    }

                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors;

                        this.$modal.show('error-modal');
                    }

                    throw TypeError("Request Failed")
                });
        },
        removeItem(item_id) {
            if (this.quantityLoading) {
                return;
            }

            let removedItem = this.cart.cart_menu_items.find(i => i.id == item_id);

            this.cart.cart_menu_items = this.cart.cart_menu_items.filter(i => i.id != item_id);

            this.updateCart()
                .catch(() => this.cart.cart_menu_items.push(removedItem));
        },
        updateTableNumber() {
            this.updateCart()
                .finally(() => this.$modal.hide('table-select'));
        },
        updateEmail() {
            if (this.isEmailValid()) {
                this.updateCart();
            }
        },
        isEmailValid() {
            return /\S+@\S+\.\S+/.test(this.cart.customer_email)
        },
        updateQuantity(item, quantity) {
            let old_quantity = item.quantity;

            item.quantity = typeof quantity === 'object'
                ? parseInt(quantity.data)
                : quantity;

            this.quantityLoading = true;

            this.updateCart()
                .catch(() => item.quantity = old_quantity)
                .finally(() => this.quantityLoading = false);
        },
        updateCovers() {
            this.updateCart()
                .finally(() => this.$modal.hide('covers-select'));
        },
        createOrder() {
            this.$axios
                .post(`/${this.siteSlug}/orders`, {
                    cart: this.cart
                })
                .then(response => {

                    if (response.data.payment) {
                        if (response.data.payment.transaction.form_implementation == 'hosted_fields') {
                            window.location = `/payments/${response.data.payment.transaction.processor}/${response.data.payment.transaction.identifier}`;
                        }
                        else {
                            this.$router.push({
                                path: `/${this.siteSlug}/cart/transaction`,
                                query: {
                                    ...response.data.payment.payload,
                                    gateway_url: response.data.payment.gateway_url
                                }
                            });
                        }
                    }
                    else {
                        window.location = `/${this.siteSlug}/orders/${response.data.order.identifier}/payment-confirmation`;
                    }
                })
                .catch(error => {
                    if (error.response.data.message) {
                        this.$toasted.error(error.response.data.message, { duration: 3000, position: "bottom-center", theme: "toasted-primary" });
                    }

                    if (!error.response.data.errors) {
                        return;
                    }

                    let showSlotChanger = false;

                    for (let error of error.response.data.errors) {
                        if (!error.code || error.code != 'CLICK_AND_COLLECT_SLOT_FULL') {
                            continue;
                        }

                        showSlotChanger = true;

                        break;
                    }

                    if (showSlotChanger) {
                        return this.$router.push(`/${this.siteSlug}/select-slot?from-cart=1&full=true`);
                    }

                    this.errors = error.response.data.errors;

                    this.$modal.show('error-modal');
                });
        },
        price(item) {
            let total = parseFloat(item.price);

            for (let modifier of item.cart_menu_item_modifiers) {
                total += modifier.quantity * modifier.price;
            }

            return total * item.quantity;
        },
        totalQuantity() {
            let quantity = 0;

            for (let item of this.cart.cart_menu_items) {
                quantity += item.quantity;
            }

            return quantity;
        },
        totalPrice() {
            let price = 0;

            for (let item of this.cart.cart_menu_items) {
                price += this.price(item);
            }

            return Math.round(price * 100) / 100;
        },
        tipAmount() {
            return Math.round((this.totalPrice() * this.cart.tip_percentage - 0.001) * 100) / 100;
        },
        totalDiscount() {
            return Math.floor(this.cart.extra.discounts.total_discount * 100) / 100;
        },
        changeTip(event) {
            if (event.target.checked) {
                this.customTIp = false;
            }
        },
        setCustomTip(event) {
            if (event.target.checked) {
                this.cart.tip_percentage = 0;
                this.customAmount = 0;
            }
        },
        back() {
            window.location = this.previousUrl.fullPath;
        },
        floor(value) {
            return Math.floor(value * 100) / 100;
        }
    },
    mounted() {
        this.fetch();
        this.fetchTables();

        this.$pageTitle = this.$t("My Cart");
    }
}
</script>
